import { PRODUCT_TYPES, TARGET_CHANNEL } from '@schuettflix/interfaces';

export const productTypeToTargetChannelMap = {
    // =================================
    // Handled by custom-request-service
    // =================================
    // Materials
    CUSTOM_BULK_MATERIAL: 'CUSTOM_REQUEST_CHANNEL',
    CUSTOM_RECYCLED_BULK_MATERIAL: 'CUSTOM_REQUEST_CHANNEL',
    CUSTOM_CONCRETE: 'CUSTOM_REQUEST_CHANNEL',
    CUSTOM_ASPHALT: 'CUSTOM_REQUEST_CHANNEL',
    // Waste
    CUSTOM_HAZARDOUS_WASTE_DISPOSAL: 'CUSTOM_REQUEST_CHANNEL',
    CUSTOM_HAZARDOUS_WASTE_RECYCLING: 'CUSTOM_REQUEST_CHANNEL',
    CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL: 'CUSTOM_REQUEST_CHANNEL',
    CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING: 'CUSTOM_REQUEST_CHANNEL',
    // Transports
    CUSTOM_TRANSPORT: 'CUSTOM_REQUEST_CHANNEL',
    // Material Services
    CUSTOM_SERVICE: 'CUSTOM_REQUEST_CHANNEL',
    CUSTOM_SERVICE_ANALYSIS: 'CUSTOM_REQUEST_CHANNEL',
    CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT: 'CUSTOM_REQUEST_CHANNEL',
    // Transport Services
    CUSTOM_SERVICE_TRANSPORT: 'CUSTOM_REQUEST_CHANNEL',
    CUSTOM_SERVICE_TOLL: 'CUSTOM_REQUEST_CHANNEL',
    CUSTOM_SERVICE_WAITING_TIME: 'CUSTOM_REQUEST_CHANNEL',
    // ===================================
    // Handled by material-channel-service
    // ===================================
    // Materials
    BULK_MATERIAL: 'MATERIAL_CHANNEL',
    RECYCLED_BULK_MATERIAL: 'MATERIAL_CHANNEL',
    // Waste
    HAZARDOUS_WASTE_DISPOSAL: 'MATERIAL_CHANNEL',
    HAZARDOUS_WASTE_RECYCLING: 'MATERIAL_CHANNEL',
    NON_HAZARDOUS_WASTE_DISPOSAL: 'MATERIAL_CHANNEL',
    NON_HAZARDOUS_WASTE_RECYCLING: 'MATERIAL_CHANNEL',
    // ============================
    // Handled by transport-service
    // ============================
    TRANSPORT: 'TRANSPORT_CHANNEL',
    // ============================
    // Not Handled by any channel
    // ============================
    SERVICE_TOLL: 'NO_CHANNEL',
    SERVICE_WEIGHING_NOTE: 'NO_CHANNEL',
    SERVICE_ACCOMPANYING_DOCUMENT: 'NO_CHANNEL',
    SERVICE_ENERGY_SURCHARGE: 'NO_CHANNEL',
} as const satisfies Record<PRODUCT_TYPES, TARGET_CHANNEL>;
